import React from "react";
import PropTypes from "prop-types";

const HeaderGlobal = ({ hTitle, hShortText, hText, hNum, bkgImage }) => {
  return (
    <header className="m-headerMarkets">
      <div
        className="_wr m-headerMarkets__wrapper"
        // style={{ backgroundImage: `url("${bkgImage}")` }}
      >
        <div className="_w m-headerMarkets__content">
          <div className="_12 _xs11 _l7 _xl6 ">
            <h1 className="m-headerMarkets__content--title">{hTitle}</h1>
            <div className="m-headerMarkets__numText">
              <p className="m-headerMarkets__numText--text">
                {hShortText}
                <span className="m-headerMarkets__numText--num"> {hNum}% </span>
                {hText}
              </p>
            </div>
          </div>
          <div
            className="m-headerMarkets__bkg _m5 _xl6"
            style={{ backgroundImage: `url("${bkgImage}")` }}
          ></div>
        </div>
      </div>
    </header>
  );
};

HeaderGlobal.defaultProps = {
  hTitle: "Lorem ipsum",
  hTextOne:
    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea, tempore?",
};

HeaderGlobal.propTypes = {
  hTitle: PropTypes.string,
  hShortText: PropTypes.string,
  hText: PropTypes.string,
};

export default HeaderGlobal;
